export default __webpack_public_path__ + "static/media/Stop.9b83beb3.svg";